import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AppWarn } from './appWarn.model';

@Injectable({
  providedIn: 'root'
})
export class WarnService {

  private subject: Subject<AppWarn> = new Subject();

  constructor() {
  }

  getSubject(): Observable<AppWarn> {
    return this.subject.asObservable();
  }

  showWarn(warnMessage: string, causes?: Array<string>): void {
    const appWarn: AppWarn = {
      warnMessage,
      causes
    };
    this.subject.next(appWarn);
  }
}
